module.exports = __webpack_public_path__ + "static/pic07.f5dbbc42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic07.jpg
// module id = 517
// module chunks = 183886176117593